import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { assessmentRouteRef, rootRouteRef } from './routes';

export const omaDashboardPage = PageBlueprint.make({
  name: 'OmaDashboardPage',
  params: {
    noHeader: true,
    path: '/dashboards/operational-maturity',
    routeRef: rootRouteRef,
    loader: () => import('./pages/dashboard').then(m => <m.OmaDashboardPage />),
  },
});

export const omaAssessmentPage = PageBlueprint.make({
  name: 'OmaAssessmentPage',
  params: {
    path: '/dashboards/operational-maturity/assessment',
    routeRef: assessmentRouteRef,
    loader: () =>
      import('./pages/assessment').then(m => <m.OmaAssessmentPage />),
  },
});

export const operationalMaturityPlugin = createFrontendPlugin({
  pluginId: 'operational-maturity',
  extensions: [omaDashboardPage, omaAssessmentPage],
  routes: {
    root: rootRouteRef,
  },
});
